import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class TextbookService {
  url=ConfigService.toApiUrl("textbooks/");

  constructor(private http:HttpClient) { }

    getAll(date:any,paccId:any){
    return this.http.get<any[]>(`${this.url}?date=${date}&paccId=${paccId}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("textbooks-by-state")}/${state}`,ConfigService.addAction('list'));
  }

  
  getByPacc(paccId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("textbooks-by-pacc")}/${paccId}`,ConfigService.addAction('list'));
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    ressource['_method']='patch';
    //ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("textbooks-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
}
